import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    username: "",
    role: "",
    token: localStorage.getItem("token"),
  },

  reducers: {
    setAuth: (state, action) => {
      state.username = action.payload.auth.name;
      state.role = action.payload.auth.authorities[0].authority;
    },
    setAuthbytoken: (state, action) => {
      state.username = action.payload.username;
      state.role = action.payload.role;
    },
    setToken: (state, action) => {
      if (!action.payload) {
        localStorage.removeItem("token");
      } else {
        localStorage.setItem("token", action.payload);
      }
      state.token = action.payload;
    },
  },
});

export const { setAuth, setAuthbytoken, setToken } = authSlice.actions;
export default authSlice.reducer;
